var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 0C3.59315 0 2.25 1.34315 2.25 3V21C2.25 22.6569 3.59315 24 5.25 24H18.75C20.4069 24 21.75 22.6569 21.75 21V3C21.75 1.34315 20.4069 0 18.75 0H5.25ZM5.25 1.5C4.42157 1.5 3.75 2.17157 3.75 3V21C3.75 21.8284 4.42157 22.5 5.25 22.5H18.75C19.5784 22.5 20.25 21.8284 20.25 21V3C20.25 2.17157 19.5784 1.5 18.75 1.5H5.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 18H21.75V19.5H2.25V18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15C14.8995 15 17.25 12.6495 17.25 9.75C17.25 6.8505 14.8995 4.5 12 4.5C9.1005 4.5 6.75 6.8505 6.75 9.75C6.75 12.6495 9.1005 15 12 15ZM12 13.5C14.0711 13.5 15.75 11.8211 15.75 9.75C15.75 7.67893 14.0711 6 12 6C9.92893 6 8.25 7.67893 8.25 9.75C8.25 11.8211 9.92893 13.5 12 13.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.75C6.75 4.16421 6.41421 4.5 6 4.5C5.58579 4.5 5.25 4.16421 5.25 3.75C5.25 3.33579 5.58579 3 6 3C6.41421 3 6.75 3.33579 6.75 3.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.75C6.75 16.1642 6.41421 16.5 6 16.5C5.58579 16.5 5.25 16.1642 5.25 15.75C5.25 15.3358 5.58579 15 6 15C6.41421 15 6.75 15.3358 6.75 15.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3.75C18.75 4.16421 18.4142 4.5 18 4.5C17.5858 4.5 17.25 4.16421 17.25 3.75C17.25 3.33579 17.5858 3 18 3C18.4142 3 18.75 3.33579 18.75 3.75Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15.75C18.75 16.1642 18.4142 16.5 18 16.5C17.5858 16.5 17.25 16.1642 17.25 15.75C17.25 15.3358 17.5858 15 18 15C18.4142 15 18.75 15.3358 18.75 15.75Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.75C12.75 10.1642 12.4142 10.5 12 10.5C11.5858 10.5 11.25 10.1642 11.25 9.75C11.25 9.33579 11.5858 9 12 9C12.4142 9 12.75 9.33579 12.75 9.75Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 19.5H9.75V22.5H8.25V19.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.5H12.75V22.5H11.25V19.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 19.5H15.75V22.5H14.25V19.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumes);
export default __webpack_public_path__ + "static/media/volumes.6483283f04603c938b37d7e7d264962e.svg";
export { ForwardRef as ReactComponent };